





























import { computed, defineComponent } from '@nuxtjs/composition-api'
import {
  QUICK_SEARCH_NS,
  QuickSearchState
} from '~/store/modules/shared/quickSearch/state'
import { useNamespacedStore } from '~/compositions/store'
import { formatNumber } from '~/utils/number'
import { tree } from '~/models/shared/tree'
import CategoryItem from '~/components/shared/quick-search/CategoryItem.vue'

export default defineComponent({
  components: { CategoryItem },
  setup() {
    const { state, getters } = useNamespacedStore<QuickSearchState>(
      QUICK_SEARCH_NS
    )

    const categoryMap = computed(() => state.categoryMap)
    const rootCategoryId = computed(() => state.config.rootCategoryId)
    const pageCategory = computed(() => getters('pageCategory'))

    const categoryTree = computed(() => tree(categoryMap.value))

    return { categoryTree, pageCategory, rootCategoryId, formatNumber }
  }
})
